import React, { useState, useEffect } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import PageShell from '../components/PageShell';
import request from '../api';

function AdminNewStore() {
    const [token] = useState(localStorage.getItem('adminToken'));
    const [name, setName] = useState('');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        if (!token) {
            navigate('/admin/login');
        }
    }, [token, navigate]);

    const logout = () => {
        localStorage.removeItem('adminToken');
        navigate('/admin/login');
    };

    const createStore = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');
        try {
            await request('/admin/stores', { method: 'POST', token, body: { name, username, password, email } });
            setName('');
            setUsername('');
            setPassword('');
            setEmail('');
            setSuccess('Tienda creada exitosamente.');
        } catch (err) {
            setError(err.message);
        }
    };

    const nav = (
        <>
            <Button component={RouterLink} to="/admin/dashboard" color="inherit">Panel</Button>
            <Button component={RouterLink} to="/auctions" color="inherit">Ver Subastas</Button>
            <Button onClick={logout} variant="outlined" color="inherit">Cerrar Sesión</Button>
        </>
    );

    return (
        <PageShell title="Nueva Tienda" nav={nav} maxWidth="md">
            <Paper sx={{ maxWidth: 420, mx: 'auto', p: { xs: 2.5, sm: 3.5 } }}>
                <Typography variant="h6" gutterBottom>Crear una Nueva Tienda</Typography>
                <Box component="form" onSubmit={createStore}>
                    <Stack spacing={2}>
                        <TextField label="Nombre de la Tienda" value={name} onChange={(e) => setName(e.target.value)} fullWidth required />
                        <TextField label="Usuario de la Tienda" value={username} onChange={(e) => setUsername(e.target.value)} fullWidth required />
                        <TextField
                            label="Contraseña de la Tienda"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            fullWidth
                            required
                        />
                        <TextField
                            label="Correo Electrónico (opcional)"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            helperText="Necesario para que la tienda pueda recuperar su contraseña"
                            fullWidth
                        />
                        <Button type="submit" variant="contained" size="large" fullWidth>Crear Tienda</Button>
                        {error && <Alert severity="error">{error}</Alert>}
                        {success && <Alert severity="success">{success}</Alert>}
                    </Stack>
                </Box>
            </Paper>
        </PageShell>
    );
}

export default AdminNewStore;
